import React, { useState, useEffect } from 'react';
import { Nav, Accordion, Collapse } from 'react-bootstrap';
import { 
  FaTachometerAlt, 
  FaMapMarkedAlt, 
  FaUserPlus, 
  FaTruck, 
  FaExclamationTriangle, 
  FaRulerCombined, 
  FaWeightHanging,
  FaPenSquare,
  FaStickyNote,
  FaChartLine,
  FaWeixin,
  FaExclamationCircle,
  FaChartBar,
  FaClipboard,
  FaMoneyBillWave,  
  FaBriefcase,
  FaFileInvoiceDollar,
  FaFileContract,
  FaSearch,
  FaRoute,
  FaWrench,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import { AiOutlineCar } from 'react-icons/ai';
import './NavbarManageComponent.css';

const NavbarManageComponent = ({ setComponentDuocChon, isSidebarOpen, toggleSidebar }) => {
  // activeLink được giữ nguyên như ban đầu
  const [activeLink, setActiveLink] = useState('dashboard');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // State cho các submenu trong Phòng Kinh Doanh
  const [businessMenuOpen, setBusinessMenuOpen] = useState({
    donKinhDoanh: false,
    khachHangHopDong: false,
    congNoDuLieu: false,
    phuongTienLoi: false,
    tinNhan: false,
  });

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Hàm xử lý activeLink như ban đầu
  const handleLinkClick = (component, event) => {
    if (event) event.stopPropagation();
    setActiveLink(component);
    setComponentDuocChon(component);

    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  const toggleBusinessMenu = (menuKey) => {
    setBusinessMenuOpen(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const isMobile = windowWidth <= 768;

  return (
    <div
      id="navbar-sidebar"
      className={`bg-white vh-100 p-1 pt-3 border-end shadow-sm ${isSidebarOpen ? 'show' : ''}`}
      style={{
        width: isMobile ? (isSidebarOpen ? '60%' : '0') : '16.67%',
        position: isMobile ? 'absolute' : 'fixed',
        top: '80px',
        left: 0,
        zIndex: 999,
        transition: 'transform 0.4s ease, opacity 0.4s ease',
        transform: isSidebarOpen || !isMobile ? 'translateX(0)' : 'translateX(-100%)',
        opacity: isSidebarOpen || !isMobile ? 1 : 0,
        overflowY: 'auto',
      }}
    >
      <Accordion defaultActiveKey="0" flush className="flex-grow-1">
        {/* 1. Bảng Điều Khiển */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Bảng Điều Khiển</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'dashboard' ? 'active' : ''}`}
                onClick={() => handleLinkClick('dashboard')}
                style={{
                  color: activeLink === 'dashboard' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'dashboard' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTachometerAlt className="me-2" /> Bản Điều Khiển
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'map' ? 'active' : ''}`}
                onClick={() => handleLinkClick('map')}
                style={{
                  color: activeLink === 'map' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'map' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaMapMarkedAlt className="me-2" /> Bản Đồ
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* 2. Quản Lý Thông Tin */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Quản Lý Thông Tin</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'createAccount' ? 'active' : ''}`}
                onClick={() => handleLinkClick('createAccount')}
                style={{
                  color: activeLink === 'createAccount' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'createAccount' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaUserPlus className="me-2" /> Tạo Tài Khoản
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'addVehicle' ? 'active' : ''}`}
                onClick={() => handleLinkClick('addVehicle')}
                style={{
                  color: activeLink === 'addVehicle' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'addVehicle' ? '#f8d7da' : 'transparent',
                }}
              >
                <AiOutlineCar className="me-2" /> Thêm Biển Kiểm Soát
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'xeKinhDoanh' ? 'active' : ''}`}
                onClick={() => handleLinkClick('xeKinhDoanh')}
                style={{
                  color: activeLink === 'xeKinhDoanh' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'xeKinhDoanh' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaTruck className="me-2" /> Chi Tiết Xe Kinh Doanh
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* 3. Cảnh Báo & Kiểm Tra */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Cảnh Báo & Kiểm Tra</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'missingTrip' ? 'active' : ''}`}
                onClick={() => handleLinkClick('missingTrip')}
                style={{
                  color: activeLink === 'missingTrip' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'missingTrip' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaExclamationTriangle className="me-2" /> Mã Chuyến Thiếu
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'wrongKm' ? 'active' : ''}`}
                onClick={() => handleLinkClick('wrongKm')}
                style={{
                  color: activeLink === 'wrongKm' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'wrongKm' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaRulerCombined className="me-2" /> Sai KM Đầu/Cuối
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'wrongWeight' ? 'active' : ''}`}
                onClick={() => handleLinkClick('wrongWeight')}
                style={{
                  color: activeLink === 'wrongWeight' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'wrongWeight' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaWeightHanging className="me-2" /> Sai Trọng Lượng
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* 4. Báo Cáo & Thống Kê */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Báo Cáo & Thống Kê</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'timTheoBKS' ? 'active' : ''}`}
                onClick={() => handleLinkClick('timTheoBKS')}
                style={{
                  color: activeLink === 'timTheoBKS' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'timTheoBKS' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaSearch className="me-2" /> Tìm Theo BKS
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'loTrinhNhap' ? 'active' : ''}`}
                onClick={() => handleLinkClick('loTrinhNhap')}
                style={{
                  color: activeLink === 'loTrinhNhap' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'loTrinhNhap' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaRoute className="me-2" /> Lộ Trình Nhập
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'baoCaoDoanhThuKD' ? 'active' : ''}`}
                onClick={() => handleLinkClick('baoCaoDoanhThuKD')}
                style={{
                  color: activeLink === 'baoCaoDoanhThuKD' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'baoCaoDoanhThuKD' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaChartLine className="me-2" /> Báo Cáo Chuyến KD
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>

        {/* 5. Phòng Kinh Doanh */}
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Phòng Kinh Doanh</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            {/* Nhóm 1: Đơn Kinh Doanh */}
            <div className="submenu-group mb-3">
              <div 
                onClick={() => toggleBusinessMenu('donKinhDoanh')}
                style={{
                  cursor: 'pointer',
                  padding: '10px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: '#6c757d',
                  fontWeight: 'bold'
                }}
              >
                <span>Đơn Kinh Doanh</span>
                {businessMenuOpen.donKinhDoanh ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <Collapse in={businessMenuOpen.donKinhDoanh}>
                <div>
                  <Nav className="flex-column">
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'taoDonKinhDoanh' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('taoDonKinhDoanh')}
                      style={{
                        color: activeLink === 'taoDonKinhDoanh' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'taoDonKinhDoanh' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaFileInvoiceDollar className="me-2" /> Tạo Đơn KD
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'ganChuyenKinhDoanh' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('ganChuyenKinhDoanh')}
                      style={{
                        color: activeLink === 'ganChuyenKinhDoanh' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'ganChuyenKinhDoanh' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaClipboard className="me-2" /> Gán Chuyến KD
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'trangThaiChuyenDaTao' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('trangThaiChuyenDaTao')}
                      style={{
                        color: activeLink === 'trangThaiChuyenDaTao' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'trangThaiChuyenDaTao' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaStickyNote className="me-2" /> Trạng Thái Chuyến
                    </Nav.Link>
                  </Nav>
                </div>
              </Collapse>
            </div>
            {/* Nhóm 2: Khách Hàng & Hợp Đồng */}
            <div className="submenu-group mb-3">
              <div 
                onClick={() => toggleBusinessMenu('khachHangHopDong')}
                style={{
                  cursor: 'pointer',
                  padding: '10px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: '#6c757d',
                  fontWeight: 'bold'
                }}
              >
                <span>Khách Hàng & Hợp Đồng</span>
                {businessMenuOpen.khachHangHopDong ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <Collapse in={businessMenuOpen.khachHangHopDong}>
                <div>
                  <Nav className="flex-column">
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'taoKhachHangMoi' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('taoKhachHangMoi')}
                      style={{
                        color: activeLink === 'taoKhachHangMoi' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'taoKhachHangMoi' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaUserPlus className="me-2" /> Thêm Khách Hàng
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'taohopdong' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('taohopdong')}
                      style={{
                        color: activeLink === 'taohopdong' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'taohopdong' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaFileContract className="me-2" /> Tạo Hợp Đồng
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'taodvkd' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('taodvkd')}
                      style={{
                        color: activeLink === 'taodvkd' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'taodvkd' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaBriefcase className="me-2" /> Thêm Đơn Vị KD
                    </Nav.Link>
                  </Nav>
                </div>
              </Collapse>
            </div>
            {/* Nhóm 3: Công Nợ & Dữ liệu */}
            <div className="submenu-group mb-3">
              <div 
                onClick={() => toggleBusinessMenu('congNoDuLieu')}
                style={{
                  cursor: 'pointer',
                  padding: '10px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: '#6c757d',
                  fontWeight: 'bold'
                }}
              >
                <span>Công Nợ & Dữ liệu</span>
                {businessMenuOpen.congNoDuLieu ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <Collapse in={businessMenuOpen.congNoDuLieu}>
                <div>
                  <Nav className="flex-column">
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'duLieuKD' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('duLieuKD')}
                      style={{
                        color: activeLink === 'duLieuKD' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'duLieuKD' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaChartBar className="me-2" /> Dữ liệu Chuyến KD
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'quanlyCongNo' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('quanlyCongNo')}
                      style={{
                        color: activeLink === 'quanlyCongNo' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'quanlyCongNo' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaFileInvoiceDollar className="me-2" /> Quản Lý Công Nợ
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'taodonCongNo' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('taodonCongNo')}
                      style={{
                        color: activeLink === 'taodonCongNo' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'taodonCongNo' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaMoneyBillWave className="me-2" /> Tạo Đơn Công Nợ
                    </Nav.Link>
                  </Nav>
                </div>
              </Collapse>
            </div>
            {/* Nhóm 4: Phương Tiện & Lỗi */}
            <div className="submenu-group mb-3">
              <div 
                onClick={() => toggleBusinessMenu('phuongTienLoi')}
                style={{
                  cursor: 'pointer',
                  padding: '10px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: '#6c757d',
                  fontWeight: 'bold'
                }}
              >
                <span>Phương Tiện & Lỗi</span>
                {businessMenuOpen.phuongTienLoi ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <Collapse in={businessMenuOpen.phuongTienLoi}>
                <div>
                  <Nav className="flex-column">
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'quanlyxe' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('quanlyxe')}
                      style={{
                        color: activeLink === 'quanlyxe' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'quanlyxe' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <AiOutlineCar className="me-2" /> Quản Lý Xe Lạnh
                    </Nav.Link>
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'tongHopChuyenKDHoanTat' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('tongHopChuyenKDHoanTat')}
                      style={{
                        color: activeLink === 'tongHopChuyenKDHoanTat' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'tongHopChuyenKDHoanTat' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaExclamationCircle className="me-2" /> Chuyến KD Lỗi
                    </Nav.Link>
                  </Nav>
                </div>
              </Collapse>
            </div>
            {/* Nhóm 5: Tin Nhắn */}
            <div className="submenu-group">
              <div 
                onClick={() => toggleBusinessMenu('tinNhan')}
                style={{
                  cursor: 'pointer',
                  padding: '10px 15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  color: '#6c757d',
                  fontWeight: 'bold'
                }}
              >
                <span>Tin Nhắn</span>
                {businessMenuOpen.tinNhan ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <Collapse in={businessMenuOpen.tinNhan}>
                <div>
                  <Nav className="flex-column">
                    <Nav.Link
                      className={`sidebar-link ${activeLink === 'tinNhanKhachHang' ? 'active' : ''}`}
                      onClick={() => handleLinkClick('tinNhanKhachHang')}
                      style={{
                        color: activeLink === 'tinNhanKhachHang' ? '#dc3545' : 'black',
                        padding: '10px 15px',
                        borderRadius: '50px',
                        backgroundColor: activeLink === 'tinNhanKhachHang' ? '#f8d7da' : 'transparent',
                      }}
                    >
                      <FaWeixin className="me-2" /> Tin Nhắn KH
                    </Nav.Link>
                  </Nav>
                </div>
              </Collapse>
            </div>
          </Accordion.Body>
        </Accordion.Item>

        {/* 6. Sửa Chữa & Bảo Dưỡng */}
        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <span style={{ color: '#dc3545', fontWeight: 'bold' }}>Sửa Chữa & Bảo Dưỡng</span>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            <Nav className="flex-column">
              <Nav.Link
                className={`sidebar-link ${activeLink === 'thongkebdsc' ? 'active' : ''}`}
                onClick={() => handleLinkClick('thongkebdsc')}
                style={{
                  color: activeLink === 'thongkebdsc' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'thongkebdsc' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaClipboard className="me-2" /> Thống Kê Bảo Dưỡng
              </Nav.Link>
              <Nav.Link
                className={`sidebar-link ${activeLink === 'baoDuongSuaChua' ? 'active' : ''}`}
                onClick={() => handleLinkClick('baoDuongSuaChua')}
                style={{
                  color: activeLink === 'baoDuongSuaChua' ? '#dc3545' : 'black',
                  padding: '10px 15px',
                  borderRadius: '50px',
                  backgroundColor: activeLink === 'baoDuongSuaChua' ? '#f8d7da' : 'transparent',
                }}
              >
                <FaWrench className="me-2" /> Tạo Đơn Sửa Chữa
              </Nav.Link>
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default NavbarManageComponent;
